Page.home = () => {
	$('.home-v1-contact-bar-mobile-slider').slick({
		arrows: false,
		autoplay: 2000,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	})
}
